import { Status } from '../model/status.model';
import { ViewTaskItem } from '../model/view-task-item.model';

export function filterByStatus(
    status: Status,
    items: ViewTaskItem[],
): ViewTaskItem[] {
    if (status == null) {
        return [...items];
    }

    return items.filter((e) => {
        return status.important !== true || e.important === true;
    });
}
